import { objectHelpers } from '@approvalmax/utils';
import { du } from 'modules/data';
import { AsyncDataProvider } from 'modules/data-providers';
import { useSelector } from 'modules/react-redux';
import { requestSelector } from 'pages/requestForm/selectors/pageSelectors';
import { getRequestEditMode } from 'pages/requestForm/selectors/requestSelectors';
import { getRuleTypeByEditMode } from 'pages/requestForm/utils/helpers';
import { FC, memo, PropsWithChildren, useCallback } from 'react';
import { api } from 'services/api';

import { mapItemSalesPrices } from '../../helpers';

const NetSuiteItemsDataProvider: FC<PropsWithChildren> = (props) => {
    const { children } = props;

    const request = useSelector(requestSelector);
    const editMode = useSelector((state) => getRequestEditMode(state, request));
    const ruleType = getRuleTypeByEditMode(editMode);

    const { id: requestId, companyId } = request;

    const onLoad = useCallback(
        async (filterText: string | null, startFrom: number, count: number) => {
            const response = await api.integration.getNetSuiteItems({
                requestId,
                ruleType,
                query: filterText,
                startFrom,
                rowNum: count,
                companyId,
            });

            return response.Values.map((item) => ({
                ...du.parseServerReference(item),
                vendorName: item.VendorName || null,
                unitList: (item.Units || []).map((unit) => ({
                    ...objectHelpers.pascalCaseToCamelCase(unit),
                    text: unit.Name,
                })),
                salesPrices: mapItemSalesPrices(item.SalesPrices),
                rate: item.PurchasePrices || null,
                purchaseDescription: item.PurchaseDescription || null,
            }));
        },
        [requestId, companyId, ruleType]
    );

    return (
        <AsyncDataProvider cacheStorageId={`requestOptions.netSuiteItems.${requestId}`} pageSize={100} onLoad={onLoad}>
            {children}
        </AsyncDataProvider>
    );
};

export default memo(NetSuiteItemsDataProvider);
